import { render } from "./UserColumnsSelectSection.vue?vue&type=template&id=f0343106&scoped=true&ts=true"
import script from "./UserColumnsSelectSection.vue?vue&type=script&lang=ts"
export * from "./UserColumnsSelectSection.vue?vue&type=script&lang=ts"

import "./UserColumnsSelectSection.vue?vue&type=style&index=0&id=f0343106&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0343106"]])

export default __exports__